/** Routes du module — propriétaire : Agent A2 — Accords commerciaux et grossistes (admin). */
import type { RouteObject } from 'react-router';
import { Handshake, Warehouse } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { PageAccord, PageAccords, PageGrossistes, PageSimulateurAccords } from './Accords';
import { PageEditeurAccord } from './Editeur';

export const routesAdminAccords: RouteObject[] = [
  { path: 'accords', element: <RequirePermission permission="accord.lire"><PageAccords /></RequirePermission> },
  { path: 'accords/nouveau', element: <RequirePermission permission="accord.gerer"><PageEditeurAccord /></RequirePermission> },
  { path: 'accords/simulateur', element: <RequirePermission permission="accord.lire"><PageSimulateurAccords /></RequirePermission> },
  { path: 'accords/:id', element: <RequirePermission permission="accord.lire"><PageAccord /></RequirePermission> },
  { path: 'accords/:id/modifier', element: <RequirePermission permission="accord.gerer"><PageEditeurAccord /></RequirePermission> },
  { path: 'grossistes', element: <RequirePermission permission="accord.lire"><PageGrossistes /></RequirePermission> },
];
export const navAdminAccords: EntreeNav[] = [
  { libelle: 'Grossistes', vers: '/admin/grossistes', permission: 'accord.lire', icone: Warehouse, groupe: 'Commercial' },
  { libelle: 'Accords commerciaux', vers: '/admin/accords', permission: 'accord.lire', icone: Handshake, groupe: 'Commercial' },
];
